import { useState } from 'react';
import { Box, Typography, TextField, Button, Paper, Alert } from '@mui/material';
import { useApp } from '../context/AppContext';
import { supabase } from '../lib/supabase';

const Profile = () => {
  const { user } = useApp();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleUpdateProfile = async () => {
    try {
      setError('');
      setSuccess('');

      // Validate passwords if trying to change password
      if (newPassword || confirmPassword) {
        if (newPassword !== confirmPassword) {
          setError('New passwords do not match');
          return;
        }

        if (!currentPassword) {
          setError('Current password is required');
          return;
        }

        // Update password
        const { error: passwordError } = await supabase.auth.updateUser({
          password: newPassword
        });

        if (passwordError) throw passwordError;
        
        setSuccess('Password updated successfully');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
        <Typography variant="h4" sx={{ mb: 4 }}>Profile Settings</Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <Box sx={{ mb: 4 }}>
          <TextField
            label="Username"
            fullWidth
            value={user?.username || ''}
            disabled
            sx={{ mb: 2 }}
          />

          <TextField
            label="Email"
            fullWidth
            value={user?.email || user?.username || ''}
            disabled
            sx={{ mb: 2 }}
          />

          <TextField
            label="Role"
            fullWidth
            value={user?.role || ''}
            disabled
            sx={{ mb: 2 }}
          />
        </Box>

        <Typography variant="h5" sx={{ mb: 3 }}>Change Password</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Current Password"
            type="password"
            fullWidth
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />

          <TextField
            label="New Password"
            type="password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <TextField
            label="Confirm New Password"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          <Button
            onClick={handleUpdateProfile}
            variant="contained"
            sx={{ 
              mt: 2,
              backgroundColor: '#e9c0e9',
              color: 'black',
              '&:hover': { backgroundColor: '#d4abd4' }
            }}
          >
            UPDATE PROFILE
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Profile; 